export async function shopifyFetch({ query, variables }) {
  // const endpoint = process.env.NEXT_PUBLIC_SHOPIFY_STORE_DOMAIN;
  const endpoint = 'https://xby66d-eh.myshopify.com/api/2024-10/graphql.json';
  // const key = process.env.NEXT_PUBLIC_SHOPIFY_STOREFRONT_ACCESS_TOKEN;
  const key = '9bdde5e971a5317d078fec1ffeef162d';

  try {
    const result = await fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": key,
      },
      body: JSON.stringify({
        query,
        variables,
      }),
    });


    const rawResponse = await result.text();

    let jsonResponse;

    try {
      jsonResponse = JSON.parse(rawResponse);
    } catch (e) {
      console.error("Failed to parse response as JSON:", e);
      throw new Error(`Invalid JSON response: ${rawResponse}`);
    }

    if (!result.ok) {
      console.error("API Response Error:", {
        status: result.status,
        statusText: result.statusText,
        body: jsonResponse,
      });
      throw new Error(`Shopify API error: ${result.status}`);
    }

    return {
      status: result.status,
      body: jsonResponse,
    };
  } catch (error) {
    console.error("Shopify fetch error:", error);
    throw error;
  }
}
